import React from 'react'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_CAMIONES_EN_TRANSITO_TOTAL } from '../../../../../config/tables'

export const TablaCamionesEnTransitoView = () => {
  return (
    <div style={{ margin: '8px auto' }}>
      <MuiTable id={TABLA_CAMIONES_EN_TRANSITO_TOTAL} />
    </div>
  )
}
